"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = __importDefault(require("./api"));
const payment_1 = __importDefault(require("./payment"));
const program_1 = __importDefault(require("./program"));
const step_layout_1 = __importDefault(require("./step-layout"));
const therapy_1 = __importDefault(require("./therapy"));
const user_1 = __importDefault(require("./user"));
exports.default = {
    user: user_1.default,
    api: api_1.default,
    payment: payment_1.default,
    program: program_1.default,
    stepLayout: step_layout_1.default,
    therapy: therapy_1.default,
};
